import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { ProsjektAvfallHeader } from './ProsjektAvfallHeader';
import { ProsjektAvfallSummaryRow } from './ProsjektAvfallSummaryRow';

type ProsjektAvfallSummaryProps = {
    isEditMode: boolean;
    totalMengde: number;
    totalMengdeSortert: number;
    totalMengdeUsortert: number;
};

export function ProsjektAvfallSummary({
    isEditMode,
    totalMengde,
    totalMengdeSortert,
    totalMengdeUsortert,
}: ProsjektAvfallSummaryProps) {
    const { t } = useTranslation();
    return (
        <Grid item={true} xs={12}>
            <ProsjektAvfallHeader
                isEditMode={isEditMode}
                showAvfallColumns={false}
            />
            <ProsjektAvfallSummaryRow
                id="summary-sortert"
                rowTitle={t('sustainability.prosjektAvfall.sortert')}
                mengde={totalMengdeSortert}
                totalMengde={totalMengde}
                isEditMode={isEditMode}
            />
            <ProsjektAvfallSummaryRow
                id="summary-usortert"
                rowTitle={t('sustainability.prosjektAvfall.usortert')}
                mengde={totalMengdeUsortert}
                totalMengde={totalMengde}
                isEditMode={isEditMode}
            />
            <ProsjektAvfallSummaryRow
                id="summary-total"
                rowTitle={t('sustainability.prosjektAvfall.totalAvfall')}
                mengde={totalMengde}
                totalMengde={totalMengde}
                isEditMode={isEditMode}
            />
        </Grid>
    );
}
